import * as React from 'react';
import BaseButton, { BaseButtonState } from '../common/BaseButton';
import { convertRGBAtoColorString } from '../../utils/ui';
import { sneCustomColors } from '../../drawing/constants';
import { getBasePath } from '../../utils/browser';

interface SNEColorUserPatternButtonProps {
  readonly onClick?: () => void;
  readonly backgroundColorIndex: number;
  readonly textColorIndex: number;
  readonly href?: string;
  readonly style?: React.CSSProperties;
  readonly title?: string;
  readonly ariaLabel?: string;
  readonly active?: boolean;
  readonly disabled?: boolean;
  readonly containerStyle?: React.CSSProperties;
}

const buttonBaseStyle: React.CSSProperties = {
  width: '122px',
  height: '52px',
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  flexShrink: 0,
  justifyContent: 'center',
  boxSizing: 'border-box',
  overflow: 'hidden',
  top: '4px',
  left: '4px',
  border: '1px #676767 solid',
};

const buttonContainerStyle: React.CSSProperties = {
  height: '130px',
  width: '60px',
  boxSizing: 'border-box',
};

const frameImageStyle: React.CSSProperties = {
  position: 'relative',
  width: '130px',
  height: '60px',
  top: '-52px',
  pointerEvents: 'none',
};

const render =  (state: BaseButtonState, props: SNEColorUserPatternButtonProps): JSX.Element => {
  const { disabled, style, backgroundColorIndex, textColorIndex } = props;
  const buttonAdditionalStyle: React.CSSProperties = {};
  let stateKey = 'out';

  if (!disabled && state.hovered && !state.pressed) {
    stateKey = 'over';
  }

  if (state.pressed) {
    stateKey = 'selected';
  }

  const colors = sneCustomColors[stateKey];
  if (colors === undefined) {
    throw new Error('Undefined color.');
  }

  buttonAdditionalStyle.backgroundColor =
    convertRGBAtoColorString(colors[backgroundColorIndex]);
  buttonAdditionalStyle.color =
    convertRGBAtoColorString(colors[textColorIndex]);

  return (
    <div style={{ ...buttonBaseStyle, ...buttonAdditionalStyle, ...style }} >
      <div>ユーザパターン</div>
    </div>
  );
};

const SNEColorUserPatternButton: React.SFC<SNEColorUserPatternButtonProps> = React.memo((props) => {
  const { onClick, href, title, ariaLabel, active, disabled, containerStyle } = props;

  const frameImageAdditionalStyle: React.CSSProperties = {};

  const baseDir = getBasePath();
  const imgSrc = `${baseDir}/images/setting-popup/frame/select_frame_bw_color_01.png`;

  frameImageAdditionalStyle.visibility = active ? 'visible' : 'hidden';

  return (
    <div style={{ ...buttonContainerStyle, ...containerStyle }}>
      <BaseButton
        render={state => render(state, props)}
        onClick={onClick}
        href={href}
        title={title}
        ariaLabel={ariaLabel}
        active={active}
        disabled={disabled} />
      <img src={imgSrc} style={{ ...frameImageStyle, ...frameImageAdditionalStyle }} />
    </div>
  );
});

export default SNEColorUserPatternButton;
